<template>
  <b-modal id="scheduleModal" ref="scheduleModal" size="xl" hide-footer class="homapt-schedule-modal">
    <div slot="modal-header" class="w-100 justify-content-center">
      <button v-on:click="hideScheduleModal" class="close d-inline" type="button" aria-label="Close">x</button>
      <div class="container-fluid">
        <div class="row">
          <div class="col text-center">
            <h3 class="m-0">Schedule A Tour</h3>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-lg-4 text-center">
          <v-day-selector v-model="date" v-bind:singleMonth="true"/>
          <b-alert variant="danger" class="my-1"
            dismissible
            :show="dateInvalid"
            @dismissed="dateInvalid">
            Please select a date.
          </b-alert>
          <!--<p>Selected Date<span class="red-text" v-if="!date">*</span>: {{ date }}</p>-->
        </div>
        <div class="col-lg-8">
          <div class="container-fluid">
            <div class="row form-row">
              <div class="col-md-3 my-auto text-right">
                <p class="mb-0">Requested Time<span class="red-text" v-if="!tourTime">*</span></p>
              </div>
              <div class="col-md-9 my-auto">
                <select v-model="tourTime" class="form-control form-control-md" v-bind:class="{'is-invalid': tourTimeInvalid, 'border-red': tourTimeInvalid}">
                  <option v-for="(time, index) in hours" v-bind:key='index'>{{ time }}</option>
                </select>
              </div>
            </div>
            <div class="row form-row">
              <div class="col-md-3 text-right my-auto">
                <p class="mb-0">Phone Number<span class="red-text" v-if="!phoneNumber">*</span></p>
              </div>
              <div class="col-md-9 my-auto">
                <vue-tel-input v-model="phoneNumber"
                  :disabledFetchingCountry="true"
                  class="form-control form-control-md phone-number"
                  v-bind:class="{'is-invalid': phoneNumberInvalid, 'border-red': phoneNumberInvalid}"
                  :onlyCountries="['us']">
                </vue-tel-input>
                <div class="invalid-feedback">
                  Please enter a valid phone number
                </div>
              </div>
            </div>
            <div class="row form-row">
              <div class="col-md-3 text-right my-auto">
                <p class="mb-0">Email<span class="red-text" v-if="!email">*</span></p>
              </div>
              <div class="col-md-9 my-auto">
                <input v-model="email"
                  class="form-control form-control-md"
                  placeholder="Enter an email"
                  v-bind:class="{'is-invalid': emailInvalid}">
                <div class="invalid-feedback">
                  Please enter a valid email address
                </div>
              </div>
            </div>
            <div class="row form-row">
              <div class="col-md-3 text-right my-auto">
                <p class="mb-0">Additional Notes</p>
              </div>
              <div class="col-md-9">
                <textarea v-model="notes"
                  class="form-control form-control-md"
                  placeholder="Let us know any additional information"
                  rows="4"></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-4 offset-2">
          <button type="button" class="btn btn-secondary" v-on:click="hideScheduleModal">Cancel</button>
        </div>
        <div class="col-4">
          <button type="button" class="btn btn-primary" v-on:click="submitEmail">Send</button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import VDaySelector from 'vuelendar/components/vl-day-selector'
import VueTelInput from 'vue-tel-input'

const times = [
  '8:00 am',
  '8:30 am',
  '9:00 am',
  '9:30 am',
  '10:00 am',
  '10:30 am',
  '11:00 am',
  '11:30 am',
  '12:00 pm',
  '12:30 pm',
  '1:00 pm',
  '1:30 pm',
  '2:00 pm',
  '2:30 pm',
  '3:00 pm',
  '3:30 pm',
  '4:00 pm',
  '4:30 pm',
  '5:00 pm',
  '5:30 pm',
  '6:00 pm',
  '6:30 pm',
  '7:00 pm',
  '7:30 pm',
  '8:00 pm'
]

export default {
  components: {
    VDaySelector,
    VueTelInput
  },
  props: {
    initialDate: {
      default: null
    }
  },
  watch: {
    initialDate: function (newValue) {
      this.date = newValue
    }
  },
  data () {
    return {
      date: this.initialDate,
      phoneNumberInvalid: false,
      emailInvalid: false,
      tourTimeInvalid: false,
      dateInvalid: false,
      phoneNumber: null,
      email: null,
      notes: null,
      tourTime: null,
      hours: times,
      formInvalid: false
    }
  },
  methods: {
    showScheduleModal () {
      this.$refs.scheduleModal.show()
    },
    hideScheduleModal () {
      this.$refs.scheduleModal.hide()
    },
    validate () {
      this.formInvalid = false

      var emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (!emailRegex.test(this.email)) {
        this.emailInvalid = true
        this.formInvalid = true
      } else {
        this.emailInvalid = false
      }

      var cellPhoneRegex = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/
      if (!cellPhoneRegex.test(this.phoneNumber)) {
        this.phoneNumberInvalid = true
        this.formInvalid = true
      } else {
        this.phoneNumberInvalid = false
      }

      if (!this.date) {
        this.dateInvalid = true
        this.formInvalid = true
      } else {
        this.dateInvalid = false
      }

      if (!this.tourTime) {
        this.tourTimeInvalid = true
        this.formInvalid = true
      } else {
        this.tourTimeInvalid = false
      }
    },
    async submitEmail () {
      this.validate()
      if (this.formInvalid) return
      var client = this.$store.getters.getEmailApigClientFactory
      var params = {}
      var pathTemplate = '/tour'
      var method = 'POST'
      var additionalParams = {}
      var body = {
        email: this.email,
        phone: this.phoneNumber,
        date: this.date,
        time: this.tourTime,
        notes: this.notes
      }
      try {
        await client.invokeApi(params, pathTemplate, method, additionalParams, body)
        this.hideScheduleModal()
        this.$bvToast.show('my-toast')
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style src="vuelendar/scss/vuelendar.scss" lang="scss"></style>
<style scoped>
.border-red {
  border-color: red !important;
}
.btn {
  margin-bottom: 1rem !important;
}

.btn-secondary {
  width: 100% !important;
}

.phone-number >>> input:placeholder {
  color: #6c757d;
}

.phone-number {
  border-color: rgb(206, 212, 218);
}

.form-row {
  margin-bottom: 1rem;
}

.red-text {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/home/homeData/rightSide/ScheduleShowingModal.vue